import { RoutesList } from '@/routes/routesList';
import { useLocation } from 'react-router-dom';

const useIsDailyPlanPage = () => useLocation().pathname === RoutesList.MyPlanDailyPage;

export default useIsDailyPlanPage;
